import type { Entity } from '@onefootprint/request-types/dashboard';
import type { TransformedDocument } from '@/entity/hooks/use-documents';

const hasSomeDiDecryptable = (entity?: Entity, documents?: TransformedDocument[]): boolean => {
  if (!entity) {
    return false;
  }
  const hasDecryptableAttributes = entity.data.some(attribute => attribute.isDecryptable);
  const hasDecryptableDocuments = !!documents && documents.some(document => document.canDecrypt);
  return hasDecryptableAttributes || hasDecryptableDocuments;
};

export default hasSomeDiDecryptable;
